import { reactive } from 'vue'
import { api } from './services/api'

export const store = reactive({
  user: null,
  ready: false,
  async loadUser() {
    try {
      const data = await api('/auth/me')
      this.user = data.user
    } catch {
      this.user = null
    } finally {
      this.ready = true
    }
  },
  async login(email, password, captcha = {}) {
    const data = await api('/auth/login', {
      method: 'POST',
      body: JSON.stringify({ email, password, ...captcha }),
    })
    this.user = data.user
    this.ready = true
    return data.user
  },
  async logout() {
    await api('/auth/logout', { method: 'POST' })
    this.user = null
  },
})

